import { Component, OnInit, Input, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { LogosInterface, LogoModel } from '../../../@core/models/site-material-data.model';
import * as Sentry from "@sentry/browser";
import { DataService } from 'src/app/@core/services/data.service';
import { FontsService } from 'src/app/@core/services/fonts.service';


@Component({
  selector: 'app-logos',
  templateUrl: './logos.component.html',
  styleUrls: ['./logos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialLogosComponent implements OnInit {

  @Input() logoImgs: LogoModel[];
  @Input() grayedOut: boolean = true;
  title: string;
  subTitle: string;
  titleColor: string;
  fontWeight: string;
  titleSize: string;
  subTitleColor: string;
  titleInputValue: string;
  backgroundColor: string;
  data: LogosInterface;
  active: boolean = false;
  position: number = 0;
  moduleInfo: string;
  classLogo: string = 'responsive-logos';
  activatePadding: boolean = false;
  @ViewChild('titleInput', { static: false }) titleInputEl: ElementRef;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  imagesAnimation: string;
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(private dataService: DataService,private fontsService:FontsService) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.imagesAnimation = this.data.animation.images != '' ? this.data.animation.images : undefined;

    }
    this.loading = false;
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "LogosComponent");
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.logoImgs = this.data.links;
    this.title = this.data.title;
    this.subTitleColor = this.data.subTitleColor;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.subTitle = this.data.subTitle;
    this.fontWeight = this.data.fontWeight ? this.data.fontWeight : '';
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.titleInputValue = this.data.title;
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.dataService.getDefaultColor(this.backgroundColor);
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }
  openLink(link: string) {
    if (link) window.open(link);
  }

  updateUrl($event) {
    const src = $event.target.src;
    $event.target.src = 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/gallery/loading.gif';
    setTimeout(() => {
      $event.target.src = src;
    }, 8000);
  }
}
